export default __webpack_public_path__ + "static/media/newDemoBenefit.e77fb51b.png";